const filterModelFormat = type =>
  type === 'date' ? { startDate: null, endDate: null } : null


const emptyModelFormat = item => 
    item.type === 'boolean' ? false : ''

const rules = fields =>
  Object.values(fields)
    .flatMap(item => ({ [item.field]: item.rules }))
    .reduce((sum, value) => ({ ...sum, ...value }))

const empty = (fields) =>
  Object.values(fields)
    .flatMap(item => ({
      [item.field]: emptyModelFormat(item)
    }))
    .reduce((sum, value) => ({ ...sum, ...value }))

const filters = fields =>
  Object.values(fields)
    .filter(item => item.filterable)
    .flatMap(item => ({
      label: item.name,
      type: item.type,
      model: filterModelFormat(item.type),
      field: item.field,
      filterWidth: item.filterWidth
    }))

export default {
  rules,
  empty,
  filters
}
